export default {
	torrent: {
		trackers: [
			'wss://avt.leanapp.cn/',
			'udp://tracker.openbittorrent.com:80',
			'udp://tracker.internetwarriors.net:1337',
			'udp://tracker.leechers-paradise.org:6969',
			'udp://tracker.coppersurfer.tk:6969',
			'udp://exodus.desync.com:6969',
			'wss://tracker.webtorrent.io',
			'wss://tracker.btorrent.xyz',
			'wss://tracker.openwebtorrent.com',
			'wss://tracker.fastcast.nz'
		]
	},
	leancloud: {
		appId: 'A1uxil2WxTsUUtUf2gSBi6iy-gzGzoHsz',
		appKey: 'JJraYYRy6Nkn3AvrSYsvJKzr',
		region: 'cn'
	}
}


/** WEBPACK FOOTER **
 ** ./config.js
 **/